var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('headerCom',{ref:"headerCom"}),_c('router-view'),_c('footerCom'),_c('payCom',{ref:"payCom"}),_c('el-backtop',{attrs:{"bottom":160}},[_c('div',{staticClass:"z-flex z-flex-col z-flex-center"},[_c('i',{staticClass:"el-icon-arrow-up"}),_c('span',{staticClass:"text"},[_vm._v("TOP")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }